import { render, staticRenderFns } from "./CombineBarChart.vue?vue&type=template&id=60861442&scoped=true"
import script from "./CombineBarChart.vue?vue&type=script&lang=js"
export * from "./CombineBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60861442",
  null
  
)

export default component.exports